export enum ModalActionTypes {
    NEUTRAL = 'neutral',
    DANGER = 'danger',
}
